import Footer from '../../../components/Footer/Footer'
import GenerateLinkPage from '../../../GenerateLink/GenerateLinkPage'
import Navbar1 from '../../../components/Navbar1/Navbar1'

export const GenerateLink = () => {
  return (
    <div>
      <Navbar1 />
      <GenerateLinkPage />
      <Footer />
    </div>
  )
}
